import type { JSX } from 'react'

import { Button } from '../design-system/button.tsx'
import { Icon } from '../design-system/icon.tsx'

/**
 * The star on the current page.
 *
 * Pressed means the page is in the reader's starred list. The name says
 * which page the toggle changes.
 *
 * @param props - Star props.
 * @param props.title - The page title, used in the accessible name.
 * @param props.pressed - Whether the page is starred.
 * @param props.onToggle - Stars the page, or unstars it.
 * @returns The toggle.
 */
export function PageStar({
  title,
  pressed,
  onToggle
}: {
  title: string
  pressed: boolean
  onToggle: () => void
}): JSX.Element {
  return (
    <Button
      data-testid="page-star"
      variant="outline"
      size="icon"
      pressed={pressed}
      aria-label={`Star ${title}`}
      onClick={onToggle}
    >
      <Icon name="star" className="size-4" />
    </Button>
  )
}
